import { createFileRoute, redirect } from '@tanstack/react-router'
import { createShipsSearch } from 'routes/ships/-searchParams'
import { Route as NewRoute } from 'routes/ships/index'

export const Route = createFileRoute('/ships/(deprecated_routes)/$siteID/')({
  beforeLoad: ({ params, search }) => {
    const siteId = params.siteID

    throw redirect({
      to: NewRoute.to,
      search: (prev) => ({
        ...prev,
        ...search,
        ...createShipsSearch({
          orgId: search.orgId,
          siteId,
        }),
      }),
      replace: true,
    })
  },
})
